const ACTION_TYPES = {};

const initialState = {
    biRewardGroups: null,
    summary: null
};

const reducer = function (state = initialState) {
    return state;
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
